import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col,
} from 'react-bootstrap';
import { getSEOFriendlyURL } from 'app/utilities/Utils';
import { Link } from 'react-router-dom';
import { STORECATEGORYPAGE } from '../../events/screens';
import * as LogClevertapEvent from 'clevertap/LogEvent';
import '../../styles/stores/stores.scss';

function StoreCategory(props) {
  const {
    isMobile, isTablet, category, urlId, 
  } = props;

  const getStoreCatUrl = (category = '', categoryId = null,viewType) => {
    const type = viewType === 'CATEGORY' ? 'c' : 'g';
    const url = `/shops/${type}/${getSEOFriendlyURL(category)}-${categoryId}`;
    return url;
  };

  return (
    <>
      {isMobile || isTablet? (
        <div className="d-flex overflow-x mx-0 bg-white">
          {
            category?.map((item) => (
            <Col
              key={item.id}
              className={`${Number(urlId)=== item.id? 'store-selected-category-bg ' : ''} selected-category-btn  `}
              onClick={() => {
                LogClevertapEvent.shopCategoryClicked( STORECATEGORYPAGE,item.description);
              }}
            >
              <Link
                to={{
                  pathname: item.id === 0 ? '/shops' : getStoreCatUrl(item.name, item.id, 'CATEGORY'),
                  state: {
                    isDefaultPage: item.id === 0,
                    scrollToTop: true,
                  },
                }}
              >
                <img
                  className="category_image"
                  src={item.image}
                  alt={item.description}
                />
                <div className={`${Number(urlId)=== item.id ? 'text-primary border-bottom-primary' : 'text-black'} py-2 text-truncate-cat text-wrap`}>
                  {item.description}
                </div>
              </Link>
            </Col>
          ))
        }
        </div>
      )
        : (
          <div className="d-inline-flex flex-column h-830 mx-lg-0">
            {
              category?.map((item) => (
              <Col
                xs="auto"
                key={item.id}
                className={`cursor-pointer ${Number(urlId)=== item.id ? 'store-selected-category-bg':''} selected-category-btn-web border-light`}
                onClick={() => {
                  LogClevertapEvent.shopCategoryClicked( STORECATEGORYPAGE,item.description);
                }}
              >
                <Link
                  to={{
                    pathname: item.id === 0 ? '/shops' : getStoreCatUrl(item.name, item.id, 'CATEGORY'),
                    state: {
                      isDefaultPage: item.id === 0,
                      scrollToTop: true,
                    },
                  }}
                > 
                  <Row 
                    className={`d-flex align-items-center px-4 flex-nowrap`}
                  >
                    <div className="px-2">
                      <img
                        className="category_image"
                        src={item.image}
                        alt={item.description}
                      />
                    </div>
                    <div
                      className={`${
                        (Number(urlId)=== item.id)
                        ? 'text-primary' : 'text-black'
                      } text-wrap flex-shrink px-2 align-left`}
                    >
                      {item.description}
                    </div>
                  </Row>
                </Link>
              </Col>
            ))
          }
        </div>
      )}
    </>
  );
}

StoreCategory.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

StoreCategory.defaultProps = {
  onSelectCategory: () => {},
};
export default StoreCategory;
